var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"px-0 vh-100",attrs:{"fluid":"","id":"app"}},[_c('b-row',{staticClass:"min-vh-100 no-gutters"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }